import { API_BASE_URL as BASE } from '@/api/apiConfig';

export interface SseEventHandlers {
  onConnected?: (data: { status: string; imageId: number }) => void;
  onStatusUpdate?: (data: { imageId: number; status: string; generatedAlt?: string; errorType?: string }) => void;
  onTimeout?: (data: { status: string; imageId: number }) => void;
  onError?: (error: Event) => void;
}

export class SseService {
  private eventSource: EventSource | null = null;
  private imageId: number | null = null;

  connect(imageId: number, handlers: SseEventHandlers) {
    // 기존 연결이 있으면 닫기
    this.disconnect();

    this.imageId = imageId;
    // EventSource는 쿠키를 자동으로 전송하지 않으므로 쿼리 파라미터로 토큰 전달
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    const url = `${BASE}/api/crawler/images/${imageId}/status-stream${token ? `?token=${token}` : ''}`;

    this.eventSource = new EventSource(url);

    this.eventSource.addEventListener('connected', (e) => {
      const data = JSON.parse(e.data);
      console.log('[SSE] 연결됨:', data);
      handlers.onConnected?.(data);
    });

    this.eventSource.addEventListener('status-update', (e) => {
      const data = JSON.parse(e.data);
      console.log('[SSE] 상태 업데이트:', data);
      handlers.onStatusUpdate?.(data);
    });

    this.eventSource.addEventListener('timeout', (e) => {
      const data = JSON.parse(e.data);
      console.log('[SSE] 타임아웃:', data);
      handlers.onTimeout?.(data);
      this.disconnect();
    });

    this.eventSource.onerror = (error) => {
      console.error('[SSE] 에러:', error);
      handlers.onError?.(error);
    };
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
      this.imageId = null;
    }
  }

  isConnected(): boolean {
    return this.eventSource !== null && this.eventSource.readyState === EventSource.OPEN;
  }
}

// 싱글톤 인스턴스
export const sseService = new SseService();
